export default "__VITE_ASSET__c7aa725b__"